import { render, staticRenderFns } from "./RecipeDetail.vue?vue&type=template&id=04da680c"
import script from "./RecipeDetail.vue?vue&type=script&lang=js"
export * from "./RecipeDetail.vue?vue&type=script&lang=js"
import style0 from "./RecipeDetail.vue?vue&type=style&index=0&id=04da680c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports